import React, { memo, useCallback, useContext } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import Input from './Input';
import { useDispatch, useSelector } from 'react-redux';
import { setShelvesFilter } from '../actions/';
import { resetShelvesFilter } from '../actions';
import { getResponsiveValue, isIOS } from '../utils';
import InterReg from './InterReg';
import AppSettingsContext from '../context/AppSettingsContext';
import Animated, { useSharedValue, useAnimatedStyle, useAnimatedReaction, interpolate, cancelAnimation, Extrapolate, withSpring } from 'react-native-reanimated';
import {Ionicons} from '@expo/vector-icons';

const tBase = 'forms.filterShelves';

const CANCEL_WIDTH = 73;
const IMPUT_HEIGHT = 45;
export const FILTER_HEIGHT = 68;
const AnimatedTouchableOpacity = Animated.createAnimatedComponent(TouchableOpacity);

function FilterBooks({ scrollY }) {
    const {t} = useContext(AppSettingsContext);
    const dispatch = useDispatch();
    const pattern = useSelector(state => state.settings.filters.shelves.pattern);
    const showClear = useSharedValue(pattern ? 1 : 0);
    
    const onPatternChange = useCallback((pattern) => {
        if(!pattern) {
            dispatch(resetShelvesFilter());
        } else {
            dispatch(setShelvesFilter({ pattern }));
        }
    }, [pattern]);

    const onPressClear = useCallback(() => {
        dispatch(resetShelvesFilter());
    })

    useAnimatedReaction(
        () => ({ showClear: showClear.value, pattern }),
        (current, previous) => {
            if(previous && !current.pattern && previous.pattern && current.showClear === 1) {
                cancelAnimation(showClear);
                showClear.value = withSpring(0, { mass: 0.1 })
            } else if(previous && current.pattern && !previous.pattern && current.showClear === 0) {
                cancelAnimation(showClear);
                showClear.value = withSpring(1, { mass: 0.1 })
            }
        }
    )
    
    const maxWidth = getResponsiveValue(['100%', '100%', '100%', '100%', 300], 'x')
    const inputTo = isIOS() ? 0 : FILTER_HEIGHT;
    const inputFrom = isIOS() ? -FILTER_HEIGHT : 0;
    const animStyles = {
        container: useAnimatedStyle(() => ({
            transform: [ { translateY: interpolate(scrollY.value, [inputFrom, inputTo], [0, -FILTER_HEIGHT], Extrapolate.CLAMP) }]
        })),
        cancel: useAnimatedStyle(() => ({
            width: interpolate(showClear.value, [0,1], [0, CANCEL_WIDTH])
        }))
    }
    return (
        <Animated.View style={[styles.container, animStyles.container]}>
            <View style={{flexDirection: 'row'}}>
                <Input 
                    inputIcon={{ Icon: Ionicons, size: 15, name: 'search' }}
                    containerStyle={{ flex: 1, maxWidth }}
                    showFormErrors={ false }
                    inputProps={{ value: pattern, onChange: onPatternChange, name: 'search' }}
                    tBase={ tBase } />
                <AnimatedTouchableOpacity 
                    onPress={onPressClear}
                    style={[styles.cancel, animStyles.cancel]}>
                    <View style={{ width: CANCEL_WIDTH, height: IMPUT_HEIGHT, alignItems: 'center', justifyContent: 'center', position: 'absolute' }}>
                        <InterReg numberOfLines={1} text={ t(`${tBase}.cancel`)} />
                    </View>
                </AnimatedTouchableOpacity>
            </View>
        </Animated.View>
    )
}

const styles = StyleSheet.create({
    container: { 
        position: 'absolute',
        zIndex: 1, 
        top: 0, 
        left: 0, 
        width: '100%', 
        paddingTop: 15, 
        paddingHorizontal: 15, 
        paddingBottom: 8, 
        height: FILTER_HEIGHT 
    },
    cancel: {
        alignItems: 'center', 
        justifyContent: 'center', 
        overflow: 'hidden',
        height: IMPUT_HEIGHT
    }
})

export default  memo(FilterBooks);